/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { TextArea, RadioButtonGroup, RadioButton, Button } from 'carbon-components-react';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import PropTypes from 'prop-types';

export default class CheckListQuestionAnswer extends Component {
  render() {
    return (
      <div className="bx--row">
        <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12">
          <fieldset className="bx--fieldset">
            <legend className="bx--label checklist-custom-content ">
              {this.props.questionCode}
              {this.props.isCustom ? (
                <>
                  <Button
                    size="small"
                    renderIcon={Edit16}
                    iconDescription="Edit"
                    onClick={this.props.onUpdateCustomRequirement}
                    kind="ghost"
                    className="checklist-custom-content-detail"
                    disabled={this.props.disabled}
                  />
                  <Button
                    size="small"
                    renderIcon={Delete16}
                    iconDescription="Delete"
                    onClick={this.props.onDeleteCustomRequirement}
                    kind="ghost"
                    className="checklist-custom-content-info "
                    disabled={this.props.disabled}
                  />
                </>
              ) : (
                ''
              )}
            </legend>
            <span className="bx--label">{this.props.question}</span>
          </fieldset>
        </div>
        <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12 align-content-center">
          <fieldset className="bx--fieldset">
            <legend className="bx--label checklist-custom-content">Answer</legend>
            <RadioButtonGroup
              id={`rbg${this.props.id}`}
              defaultSelected={this.props.answer}
              labelPosition="right"
              legend="Group Legend"
              name={`rbg${this.props.id}`}
              // onChange={this.props.onAnswerChange}
              orientation="horizontal"
              valueSelected={this.props.answer}
              disabled={this.props.disabled}
            >
              <RadioButton
                className="some-class"
                id={`btnNO${this.props.id}`}
                onClick={() => this.props.onAnswerChange('No')}
                labelText="No"
                value="No"
                disabled={this.props.disabled}
              />
              <RadioButton
                className="some-class"
                id={`btnYes${this.props.id}`}
                onClick={() => this.props.onAnswerChange('Yes')}
                labelText="Yes"
                value="Yes"
                disabled={this.props.disabled}
              />
              <RadioButton
                className="some-class"
                id={`btnNA${this.props.id}`}
                onClick={() => this.props.onAnswerChange('N/A')}
                labelText="N.A."
                value="N/A"
                disabled={this.props.disabled}
              />
              <RadioButton
                className="some-class"
                id={`btnNV${this.props.id}`}
                onClick={() => this.props.onAnswerChange('NV')}
                labelText="Not verified"
                value="NV"
                disabled={this.props.disabled}
              />
            </RadioButtonGroup>
          </fieldset>
        </div>
        <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12">
          <fieldset className="bx--fieldset">
            <legend className="bx--label checklist-custom-content">Notes</legend>
            <TextArea
              maxLength={5000}
              labelText=""
              className="some-class"
              cols={50}
              disabled={this.props.disabled}
              light={false}
              onChange={this.props.onNoteChange}
              placeholder=""
              rows={4}
              value={this.props.note || ''}
            />
          </fieldset>
        </div>
      </div>
    );
  }
}

CheckListQuestionAnswer.propTypes = {
  id: PropTypes.string.isRequired,
  questionCode: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.string,
  note: PropTypes.string,
  isCustom: PropTypes.bool,
  onAnswerChange: PropTypes.func.isRequired,
  onNoteChange: PropTypes.func.isRequired,
  onDeleteCustomRequirement: PropTypes.func,
  onUpdateCustomRequirement: PropTypes.func,
  disabled: PropTypes.bool,
};
CheckListQuestionAnswer.defaultProps = {
  answer: null,
  note: null,
  isCustom: false,
  disabled: true,
  onDeleteCustomRequirement: () => {},
  onUpdateCustomRequirement: () => {},
};
